export default {
  allVehicleColors: [],
}
